// extracted by mini-css-extract-plugin
module.exports = {"navLink":"Navbar_navLink__23lRM","whiteText":"Navbar_whiteText__XSFoQ"};